import { render } from "./HealthVideos.vue?vue&type=template&id=fe4ca2ec&scoped=true"
import script from "./HealthVideos.vue?vue&type=script&lang=js"
export * from "./HealthVideos.vue?vue&type=script&lang=js"

import "./HealthVideos.vue?vue&type=style&index=0&id=fe4ca2ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4ca2ec"]])

export default __exports__